<template>
  <v-main class="d-flex align-center justify-center h-screen">
    <v-card width="1100" class="pa-4 error-card">
      <v-card-title class="screen-title"> ネットワーク接続エラー </v-card-title>
      <v-card-text class="pt-4">
        ネットワーク接続ができませんでした。<br />
        お客様のネットワーク環境をご確認の上、再度接続をお願いします。
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn to="/" color="primary" variant="flat">HOME</v-btn>
      </v-card-actions>
    </v-card>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NetworkErrorView",
});
</script>
